exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kv-amount[data-v-4c591b3f] {\n  white-space: nowrap;\n}\n.kv-amount-cents[data-v-4c591b3f] {\n  font-size: 0.6em;\n}\n", ""]);

// exports
